@if (btnEnabled('shareBtn')) {
  <div class="btn-group btn-group-sm" role="group">
      <button class="btn btn-outline-light" (click)="copyShareLink()" title="Copy Shareable Link">
          <i class="fas fa-share-square"></i>
      </button>
  </div>
}
